import { Component, OnInit, inject } from '@angular/core';
import {GameService} from "../../services/game.service";
import {GamePlay} from "../../model/game-play";
import {Location} from "@angular/common";
import {GameStatus} from "../../model/gameStatus";
import {SendStatsDialogComponent} from "../send-stats-dialog/send-stats-dialog.component";
import {MatDialog} from "@angular/material/dialog";
import {AuthService} from "../../services/auth.service";
import { Router, RouterLink } from "@angular/router";
import { MatIcon } from '@angular/material/icon';
import { ButtonToggleGroupComponent } from '../button-toggle-group/button-toggle-group.component';
import { MatButtonToggleGroup, MatButtonToggle } from '@angular/material/button-toggle';
import { MatIconButton, MatButton } from '@angular/material/button';
import { TranslocoModule } from '@ngneat/transloco';

@Component({
    selector: 'app-dialog-game-play-list',
    templateUrl: './game-play-list.component.html',
    styleUrls: ['./game-play-list.component.scss'],
    imports: [MatIcon, ButtonToggleGroupComponent, MatButtonToggleGroup, MatButtonToggle, MatIconButton, RouterLink, MatButton, TranslocoModule]
})
export class GamePlayListComponent implements OnInit {
  game = inject(GameService);
  private location = inject(Location);
  router = inject(Router);
  dialog = inject(MatDialog);
  private authService = inject(AuthService);

  editedGamePlay?: GamePlay
  qtrFilter?: number = undefined
  showSendStatsIcon = true
  showSendHudlIcon = false

  async ngOnInit() {
    if (!this.game.game) {
      const gameInfo = window.localStorage.getItem('gameInfo')
      if (gameInfo) {
        await this.game.selectGame(JSON.parse(gameInfo))
      }
    }
    //TODO: Fix temporaire a Fixer avec une solution plus propre dans le billet #487
    if (this.game.game.gameStatus !== GameStatus.InReview) {
      this.qtrFilter = this.game.getFirstPendingGamePlay().qtr
    }
    if (this.game.game.homeTeam.isPayingTeam && await this.authService.isUserWithPayingTeam()) {
      this.showSendStatsIcon = true
      this.showSendHudlIcon = false
    } else {
      this.showSendStatsIcon = false
      this.showSendHudlIcon = true
    }
  }

  selectQuarter(qtr: (number | undefined)) {
    this.qtrFilter = qtr
  }

  getPlayList(): GamePlay[] {
    const quarterFilter = (gamePlay: GamePlay) => gamePlay.qtr === this.qtrFilter;
    const noFilter = () => true;
    const filter = this.qtrFilter ? quarterFilter : noFilter

    return this.game.gamePlayList
      .filter(filter)
      .sort((a, b) => (b.gamePlayNumber || 0) - (a.gamePlayNumber || 0));
  }

  generateStatsPDF() {
    this.game.openStats()
  }

  sendStatsByEmail() {
    const dialogRef = this.dialog.open(SendStatsDialogComponent, {
      data: {
        titleKey: 'sendStats.title',
        descriptionKey: 'sendStats.description',
        cancelKey: 'sendStats.cancel',
        actionBtnKey: 'sendStats.sendStatsBtn'
      }
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result.action === "end") {
        this.game.sendGameStats();
      }
    });
  }

  sendHudlDocByEmail() {
    const dialogRef = this.dialog.open(SendStatsDialogComponent, {
      data: {
        titleKey: 'sendHudl.title',
        descriptionKey: 'sendHudl.description',
        cancelKey: 'sendHudl.cancel',
        actionBtnKey: 'sendHudl.sendHudlBtn'
      }
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result.action === "end") {
        this.game.sendHudlStats();
      }
    });
  }

  back() {
    if (this.game.game.gameStatus === GameStatus.InReview) {
      window.localStorage.removeItem('gameInfo')
      this.router.navigate(['/']);
    }
    this.location.back();
  }

  protected readonly GameStatus = GameStatus;
    protected readonly undefined = undefined;

  addGamePlay(gamePlayNumber: number) {
    if (gamePlayNumber === 0) {
      return
    }
    const newGamePlay = gamePlayNumber + "b"
    this.router.navigate(['/game-play-list', newGamePlay]);
  }
}
